import { Box, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTextField from "../../../components/customFields/CustomTextField";
import CustomMuiltiLineTextField from "../../../components/customFields/CustomMuiltiLineTextField";
import BlueOutlinedButton from "../../../components/customButtons/BlueOutlineButton";
import BlueMediumButton from "../../../components/customButtons/BlueMediumButton";
import {
  handleFetchClassLeaveCalandar,
  handleSendLeaveRequest,
} from "../../testPrepDashboard/Api/DashboardApi";
import { useParams } from "react-router-dom";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import "../../testPrepEnrolment/calendar.css";
import Loader from "../../../../SAPPages/components/Loader/Loader";
import InfoIcon from "@mui/icons-material/Info";
import DisableBlueSmallButton from "../../../components/customButtons/DisableSmallBlueButton";

export default function RequestLeaveForm({
  handleClose,
  handleOpenSuccessPopup,
  setMessageTitle,
  setSubMessage,
}) {
  const userId = localStorage.getItem("userId");
  const { std_class_detail_id } = useParams();
  const [startDate, setStartDate] = useState();
  const [endDate, setEnddate] = useState(null);

  const [reason, setReason] = useState(null);

  const [errors, setErrors] = useState({});
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [slotsData, setSlotsData] = useState([]);
  const [classSlotesLoding, setClassSlotLoading] = useState(true);

  // validate leave
  const validateLeave = () => {
    const newErrors = {};

    if (!startDate) newErrors.startDate = "Start date is required";

    if (!endDate) newErrors.endDate = "End date is required";

    if (!reason) newErrors.reason = "Reason is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    // gives YYYY-MM-DD in IST
  };

  // Only allow dates that have slots
  const filterDate = (date) => {
    const dateStr = formatDate(date);
    const dateObj = slotsData.find((d) => d.date === dateStr);

    return dateObj?.is_class === true;
  };

  // Highlight dates with available slots
  const customDayClass = (date) => {
    const dateStr = formatDate(date);
    const dateObj = slotsData.find((d) => d.date === dateStr);

    if (dateObj?.is_class === true) {
      return "react-datepicker__day--highlighted-pink"; // pink
    } else {
      return "react-datepicker__day--disabled"; // disabled
    }
  };

  // Highlight dates with available slots
  const customDayEndClass = (date) => {
    const dateStr = formatDate(date);
    const dateObj = slotsData.find((d) => d.date === dateStr);

    if (
      dateObj?.is_class === true &&
      dateObj?.date > startDate?.toISOString().split("T")[0]
    ) {
      return "react-datepicker__day--highlighted-pink"; // pink
    } else {
      return "react-datepicker__day--disabled"; // disabled
    }
  };

  // add 1 day
  const addOneDay = (date) => {
    if (!date) return null;
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  };

  // submit leave request data
  const handleSubmitData = async () => {
    if (validateLeave()) {
      const startDatePlusOne = addOneDay(startDate);
      const endDatePlusOne = addOneDay(endDate);
      try {
        const response = await handleSendLeaveRequest({
          user_id: parseInt(userId),
          student_class_details_id: std_class_detail_id,

          reason: reason,
          start_date: startDatePlusOne?.toISOString().split("T")[0],
          end_date: endDatePlusOne.toISOString().split("T")[0],
          calender_arr:slotsData
        });

        if (response.status === 201) {
          handleClose();
          setMessageTitle("Leave request sent successfully.");
          setSubMessage(
            "We’ve received your leave request and will process it shortly."
          );
          handleOpenSuccessPopup();
        } else {
          setErrorMessage(response?.message);
          handleOpenErrorPopup();
        }
      } catch (error) {
        setErrorMessage(error);
        handleOpenErrorPopup();
      }
    } else {
      console.log("Validation error");
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  // fetch available class
  const handleClassLeaveCalandar = async () => {
    try {
      setClassSlotLoading(true);
      const response = await handleFetchClassLeaveCalandar({
        user_id: parseInt(userId),
        student_class_details_id: std_class_detail_id,
      });

      if (response.status === 200) {
        setSlotsData(response?.data);
        setErrorMessage(
          " No class slots are available for the next 30 days. Please check back later"
        );
        setClassSlotLoading(false);
      } else {
        setSlotsData([]);
        setErrorMessage(response?.message);
        setClassSlotLoading(false);
      }
    } catch (error) {
      setSlotsData([]);
      setErrorMessage(
        "No class slots are available for the next 30 days. Please check back later"
      );
      setClassSlotLoading(false);
    }
  };

  useEffect(() => {
    handleClassLeaveCalandar();
  }, []);

  return (
    <>
      <Grid container spacing={2.5}>
        {classSlotesLoding ? (
          <Grid item xs={12}>
            <Loader text="Loading Class Slot" height="20vh" />
          </Grid>
        ) : !classSlotesLoding && slotsData?.length === 0 ? (
          <Grid
            item
            xs={12}
            textAlign="center"
            display="flex"
            justifyContent="center"
            height="200px"
          >
            <Box
              sx={{
                background: "#BA15150F",
                padding: "10px",
                borderRadius: "8px",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={1}
            >
              {/* <InfoIcon style={{ color: "#BA1515" }} /> */}
              <Typography
                fontSize="14px"
                color="#BA1515"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  lineHeight: "1.4",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                {errorMessage}
              </Typography>
            </Box>
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography
                color="#333333"
                fontFamily="Inter"
                fontSize="14px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                mb={1}
                style={{ fontWeight: 400 }}
              >
                Start Date <span style={{ color: "#CE0E00" }}>*</span>
              </Typography>

              <DatePicker
                fullWidth
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  setEnddate(null);
                }}
                filterDate={filterDate}
                dayClassName={customDayClass}
                dateFormat="dd - MM - yyyy"
                customInput={
                  <CustomTextField
                    fullWidth
                    variant="outlined"
                    borderColor="#E6E2F7"
                    size="small"
                    color="#9D0385"
                    fontWeight={700}
                    fontSize={13}
                    error={!!errors.startDate}
                    helperText={errors.startDate}
                    InputProps={{
                      endAdornment: (
                        <CalendarTodayIcon
                          style={{ cursor: "pointer", fontSize: "1rem" }}
                        />
                      ),
                    }}
                  />
                }
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                color="#333333"
                fontFamily="Inter"
                fontSize="14px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                mb={1}
                style={{ fontWeight: 400 }}
              >
                End Date <span style={{ color: "#CE0E00" }}>*</span>
              </Typography>

              <DatePicker
                fullWidth
                selected={endDate}
                onChange={(date) => setEnddate(date)}
                filterDate={filterDate}
                dayClassName={customDayEndClass}
                dateFormat="dd - MM - yyyy"
                customInput={
                  <CustomTextField
                    fullWidth
                    variant="outlined"
                    borderColor="#E6E2F7"
                    size="small"
                    color="#9D0385"
                    fontWeight={700}
                    fontSize={13}
                    error={!!errors.endDate}
                    helperText={errors.endDate}
                    InputProps={{
                      endAdornment: (
                        <CalendarTodayIcon
                          style={{ cursor: "pointer", fontSize: "1rem" }}
                        />
                      ),
                    }}
                  />
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                color="#333333"
                fontFamily="Inter"
                fontSize="14px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                mb={1}
                style={{ fontWeight: 400 }}
              >
                Reason <span style={{ color: "#CE0E00" }}>*</span>
              </Typography>

              <CustomMuiltiLineTextField
                placeholder="Please Provide a reason for your leave"
                fontSize="14px"
                fullWidth
                rows={2}
                onChange={(e) => setReason(e.target.value)}
                value={reason}
                error={!!errors.reason}
                helperText={errors.reason}
              />
            </Grid>

            <Grid item xs={12} container gap={1} justifyContent="center">
              <BlueOutlinedButton buttonTitle="Cancel" onClick={handleClose} />

              <BlueMediumButton
                buttonTitle="Submit Request"
                onClick={handleSubmitData}
              />
            </Grid>
          </>
        )}
      </Grid>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle="Got It"
        maxWidth="xs"
      />
    </>
  );
}
